<template>
  <b-modal
    id="winModal"
    hide-header-close
    size="lg"
    centered
    @close="$emit('close')"
    @hide="$emit('close')"
  >
    <b-row class="d-flex flex-fill">
      <b-col :cols="12" class="d-flex flex-column justify-content-center  pb-5 pb-sm-4">
        <div class="d-flex flex-column modal-container">
          <div class="closeIcon" @click="closeModal">
            <svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
              <path d="M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z" />
            </svg>
          </div>
            <b-img
              :src="require(`../assets/winModalImages/title-${winType}.png`)"
              class="win-title"
              fluid
            />
          <picture>
            <source
              :srcset="require(`../assets/winModalImages/win-${winType}.webp`)"
              type="image/webp"
            />
            <b-img
              :src="require(`../assets/winModalImages/win-${winType}.png`)"
              class=""
              fluid
            />
          </picture>
          <div v-if="coupon" class="coupon-wrapper d-flex justify-content-center mb-3">
            <div class="coupon coupon-border d-flex justify-content-center">
              <div class="code d-flex justify-content-center align-items-center">
                {{ coupon }}
              </div>
              <div
                :class="[
                  'copy d-flex justify-content-center align-items-center',
                  isCouponCopied && 'copied'
                ]"
                v-clipboard:copy="coupon"
                v-clipboard:success="onSuccessCopy"
              >
                {{ copyButtonText }}
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center w-100 modal-cta">
            <a v-if="coupon" :href="url + coupon + '&lp=coupon'" class="modalButton button">
              Claim My Bonus
            </a>
            <a v-else-if="!coupon" @click="closeModal" class="modalButton button">
              SPIN AGAIN
            </a>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import jQuery from 'jquery'
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

export default {
  name: 'Modal',
  props: {
    winType: {
      type: Number,
      default: null,
      required: true
    },
    coupon: {
      type: String,
      default: null,
      required: true
    },
    url: {
      type: String,
      default: null,
      required: true
    }
  },
  data () {
    return {
      copyButtonText: 'COPY CODE',
      isCouponCopied: false
    }
  },
  methods: {
    closeModal () {
      this.$bvModal.hide('winModal')
      this.$emit('close')
    },
    onSuccessCopy () {
      this.isCouponCopied = true
      this.copyButtonText = 'COPIED!'
      setTimeout(() => {
        this.copyButtonText = 'COPY CODE'
        this.isCouponCopied = false
      }, 5000)
    }
  },
  mounted () {
    this.$bvModal.show('winModal')
    setTimeout(() => {
      const DomContentLoadedEvent = document.createEvent('Event')
      DomContentLoadedEvent.initEvent('DOMContentLoaded', true, true)
      window.document.dispatchEvent(DomContentLoadedEvent)
    }, 350)
    setTimeout(() => {
      // eslint-disable-next-line no-undef
      setTimeout(() => {
        // eslint-disable-next-line no-undef
        jQuery('.modalButton').mouseenter()
      }, 50)
    }, 250)
  }
}
</script>

<style lang="scss">
.closeIcon {
  background-color: #8a0911;
  border: 4px solid #ceab63;
  border-radius: 45px;
  position: absolute;
  top: 0px;
  right: 25px;
  left: auto;
  @media (min-width: 576px) {
    right: 45px;
    top: 35px;
    width: 50px;
    height: 50px;
  }
  width: 30px;
  height: 30px;
  cursor: pointer;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  * {
    transition: all 0.2s ease-in-out;
  }
  svg {
    transform: translateY(-1px);
    width: 26px;
    height: 26px;
    fill: #f5dfa7;
    @media (max-width: 576px) {
    width: 20px;
    height: 20px;
  }
  }
  &:hover {
    background-color: #bd242e;
  }
}
#winModal {
  background-color: rgba(10,6,19,.85);
  .modal-container{
    position: relative;
    width: 100%;
    max-width: 526px;
    padding: 20px;
    margin: 10% auto;
    background: url('../assets/party-bg.png');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center 10px;
    background-attachment: 100% 100%;
    .win-title{
      max-width: 245px;
      margin: 0 auto;
    }
    .modal-cta{
      margin: 10px auto 0;
      font-weight: 900;
      .button{
        text-transform: uppercase;
        padding: 18px 10px;
        width: 80%;
        border-radius: 10px;
        border: none;
        font-size: 28px;
        min-width: 150px;
        max-width: 380px;
        text-align: center;
        cursor: pointer;
        outline: none;
        color: #77060b !important;
        transition: 0.7s;
        background: rgb(206,171,99);
        text-decoration: none;
        background: linear-gradient(0deg, rgba(206,171,99,1) 0%, rgba(245,223,167,1) 100%);
        &:hover {
              color: #fc4854 !important;
        }
        @media (max-width: 576px) {
          width: 100%;
          font-size: 20px;
        }
      }
    }
  }
  .modal-content {
    background: transparent;
    position: relative;
    margin: auto;
    box-sizing: border-box;
    background-clip: padding-box;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
      margin: -3px;
      border-radius: inherit;
    }
    .modal-header {
      display: none;
    }
    .modal-footer {
      display: none;
    }
    .modal-body {
      text-align: center;
      display: flex;
      min-height: 30vh;
      color: #d6c19e;
      font-size: 10px;
      .coupon-wrapper {
        width: 100%;
        height: 50px;
        .coupon {
          max-width: 380px;
          display: flex;
          padding: 0;
          margin: 0 auto;
          width: 100%;
          .code {
            width: 55%;
            color: #f5dfa7;;
            background-color: #77060b;
            border-radius: 5px 0px 0px 5px;
            border: 1px solid #f5dfa7;
            margin: 0 !important;
            font-size: 25px;
            padding: 7px 0;
            @media (max-width: 576px) {
              font-size: 22px;
            }
          }
          .copy {
            background: linear-gradient(0deg, rgba(206,171,99,1) 0%, rgba(245,223,167,1) 100%);
            cursor: pointer;
            width: 50%;
            color: #77060b !important;
            font-size: 23px;
            transition: all 0.3s ease-in-out;
            border-radius: 0px 5px 5px 0px;
            font-weight: 900;
            &:hover {
              color: #fc4854 !important;
            }
            &.copied {
              background: linear-gradient(0deg, rgba(206,171,99,1) 0%, rgba(245,223,167,1) 100%);
              color: #77060b !important;
            }
          }
        }
      }
      .image-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          max-height: 225px;
        }
      }
      @media (min-width: 576px) {
        .image-wrapper {
          position: absolute;
          top: -20%;
          left: -40%;
          width: 150%;
          height: 140%;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            max-height: none;
          }
        }
      }
    }
  }
  @media (max-width: 576px) {
    body {
      background: red;
    }
    .modal-content {
      margin: 60px 0 !important;
      .win-title{
      max-width: 170px;
      margin: 0 auto;
        }
      .modal-header {
        display: none;
        top: -50px;
        padding-top: 10px;
        img {
          max-height: 33px;
        }
      }
      .modal-body {
        max-height: 75vh;
        #winImage {
          max-height: 125px !important;
          transform: scale(1.25) translateY(5px);
        }
        .code {
        }
        .copy {
          font-size: 16px !important;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>
